import { Card, SkeletonBodyText } from "@medentic/polaris-react";
import { Patient } from "../../types";

interface OverviewTabContentProps {
  patient?: Patient;
  loading?: boolean;
}

function OverviewTabContent({ patient, loading }: OverviewTabContentProps) {
  if (loading) {
    return (
      <Card>
        <SkeletonBodyText lines={10} />
      </Card>
    );
  }

  return <Card>{patient?.core_notes}</Card>;
}

export default OverviewTabContent;
